import { formatNumber } from '../utils/format';

export function normalizeBarRow(row, index) {
  if (Array.isArray(row)) {
    return {
      key: `${row[0]}-${index}`,
      label: row[0],
      value: row[1],
      detail: row[2] || null,
      payload: null,
    };
  }
  return {
    key: `${row?.label ?? 'row'}-${index}`,
    label: row?.label,
    value: row?.value,
    detail: row?.detail || null,
    payload: row?.payload ?? null,
  };
}

export default function HorizontalBarChart({
  items,
  emptyMessage,
  allowNegative = false,
  onRowActivate,
}) {
  const rows = (items || []).map(normalizeBarRow);
  const max = allowNegative
    ? Math.max(...rows.map((row) => Math.abs(row.value)), 1)
    : Math.max(...rows.map((row) => row.value), 1);

  if (rows.length === 0) {
    return <p className="chart-empty">{emptyMessage}</p>;
  }

  return (
    <ul className="bar-chart" aria-label="Bar chart">
      {rows.map((row) => {
        const fullLabel = row.detail ? `${row.label} · ${row.detail}` : String(row.label ?? '');
        return (
          <li
            key={row.key}
            className={
              onRowActivate && row.payload ? 'bar-chart-row bar-chart-row-activatable' : 'bar-chart-row'
            }
            title={`${fullLabel}: ${formatNumber(row.value)}`}
          >
            <span className="bar-chart-label" title={fullLabel}>
              <span className="bar-chart-label-primary">{row.label}</span>
              {row.detail ? <span className="bar-chart-label-detail">{row.detail}</span> : null}
            </span>
            <div
              className={`bar-chart-track${allowNegative ? ' bar-chart-track-signed' : ''}`}
              aria-hidden="true"
            >
              {allowNegative ? (
                <div
                  className={`bar-chart-fill ${
                    row.value < 0 ? 'bar-chart-fill-negative' : ''
                  }`}
                  style={{
                    width: `${(Math.abs(row.value) / max) * 50}%`,
                    left: row.value < 0 ? `${50 - (Math.abs(row.value) / max) * 50}%` : '50%',
                  }}
                />
              ) : (
                <div
                  className="bar-chart-fill"
                  style={{ width: `${(row.value / max) * 100}%` }}
                />
              )}
            </div>
            <span className="bar-chart-value">{formatNumber(row.value)}</span>
            {onRowActivate && row.payload ? (
              <button
                type="button"
                className="bar-chart-open"
                onClick={() => onRowActivate(row.payload)}
              >
                Open
              </button>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
